import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router';
import { App } from 'src/App';
import { AuthProvider } from 'src/lib/auth/AuthProvider';
import { createI18n } from 'src/lib/i18n/i18n';
import { detectLanguage, readSavedLanguage } from 'src/lib/i18n/language';

const i18n = createI18n(detectLanguage(readSavedLanguage(), navigator.languages));

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </I18nextProvider>
  </StrictMode>,
);
